<template>
  <div class="container-fluid p-0">

    <div class="row">
      <div class="col-12 mb-2">
        <div class="row align-items-center text-center">
          <div class="col-12 text-center">
            <button v-b-modal.create-pattern class="btn iconed btn-secondary"><i
              class="icon-bd-plus"></i><span>جدید</span></button>
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="col-12 p-0">
        <Preloader/>
      </div>
      <div v-else class="col-12 mb-2">
        <div class="col-lg-12 p-0">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col" class="text-center">عملیات</th>
              <th scope="col" class="text-center">نام الگو</th>
              <th scope="col" class="text-center">نام محصول</th>
              <th scope="col" class="text-center">کارگاه مبدا</th>
              <th scope="col" class="text-center">کارگاه مقصد</th>
              <th scope="col" class="text-center">محصولات
                <!--<table class="table table-striped">-->
                <!--<thead>-->
            <tr>
              <th scope="col" class="text-center">نام محصول</th>
              <th scope="col" class="text-center">تعداد</th>
            </tr>
            <!--</thead>-->
            <!--</table>-->
            </th>
            <th scope="col" class="text-center">زمان استاندارد(ساعت)</th>
            <th scope="col" class="text-center">الگوی پیش فرض</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in patterns">
              <td class="text-center">
                <button :id="'btn-precondition-' + item.id" class="btn btn-secondary ml-2"
                        :class="{'btn-warning': patternDecoration === 'suspend'}"
                        @click="createPatternDecoration(item, index)"
                        data-toggle="tooltip" title="مشخص کردن روابط بین کارگاه ها"><i class="icon-calendar-edit"></i>
                </button>
                <button :id="'btn-precondition-' + item.id" class="btn btn-secondary ml-2"
                        :class="{'btn-warning': patternDecoration === 'suspend'}"
                        @click="patternDefult(item, index)"
                        data-toggle="tooltip" title="این الگو به عنوان پیش فرض باشد"><i class="icon-checkbox-marked-circle-outline"></i>
                </button>
                <button :id="'btn-delete-' + item.id" v-b-modal.delete-pattern class="btn btn-secondary ml-2"
                        :class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onDeleteClicked(item, index)"><i
                  class="icon-bd-delete"></i></button>
              </td>
              <td class="text-center">{{item.name}}</td>
              <td class="text-center">{{item.productName}}</td>
              <td class="text-center">{{item.firstCompany}}</td>
              <td class="text-center">{{item.lastCompany}}</td>
              <table class="table table-striped">
                <tbody>
                <tr v-for="(pr, index2) in item.rawMaterials">
                  <td class="text-center">{{pr.productName}}</td>
                  <td class="text-center">{{pr.count}}</td>
                </tr>
                </tbody>
              </table>
              <td class="text-center">{{item.standardTime}}</td>
              <td class="text-center"><span class="badge badge-success">{{checkDefault(item.isDefault)}}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12">
          <b-pagination
            align="center"
            @input="onProductPaginationChange"
            :total-rows="rows"
            :per-page="pagination.pageSize"
          ></b-pagination>
        </div>
      </div>
      <b-modal
        ref="pattern"
        id="create-pattern"
        size="xl"
        title="ایجاد الگو"
        ok-title="ذخیره"
        cancel-title="لغو"
        @cancel="hideModal"
        @ok="savePattern"
      >
        <div class="row">
          <div class="col-6">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>محصول</span>
                </div>
              </div>
              <!--<input v-model="server.name" type="text" class="form-control">-->
              <vs-select
                ref="products"
                :data="productsName"
                :header="{label:'productName'}"
                :mode="'edit'"
                :is-header="true"
                :selected-val="productSelectedVal"
                @onChange="onProductChange"
              ></vs-select>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>نام الگو</span>
                </div>
              </div>
              <input v-model="patternName" type="text" class="form-control">
            </div>
          </div>
          <div class="col-12 mt-2">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>کارگاه ها</span>
                </div>
              </div>
              <!--<input v-model="server.name" type="text" class="form-control">-->
              <vs-select
                ref="companies"
                :data="companies"
                :header="{label:'companyName', multiple: true}"
                :mode="'edit'"
                :is-header="true"
                :selected-val="companySelectedVal"
                @onChange="onCompanyChange"
              ></vs-select>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        ref="pattern-decoration"
        id="pattern-preconditions"
        size="xl"
        title="الگو"
        ok-title="ذخیره"
        cancel-title="لغو"
        @cancel="hideModal"
        @ok="savePatternDecoration"
      >
        <pattern-dependencies
          :preconditions="editingPattern.preconditions"
          :pattern="editingPattern.pattern"
          :stateItems="stateItems"
          :stateQuestions="stateQuestions"
          ref="patternDependencies"
          @add-new-precondition="addNewPrecondition"
          @add-new-question="addNewQuestion"
          @remove-precondition="removePrecondition"
        ></pattern-dependencies>
      </b-modal>
      <b-modal
        ref="deleteModal"
        id="delete-pattern"
        :header-bg-variant="headerBgVariant"
        :body-bg-variant="bodyBgVariant"
        :footer-bg-variant="footerBgVariant"
        :header-text-variant="headerTextVariant"
        size="sm"
        title="حذف الگو"
        ok-title="حذف"
        cancel-title="لغو"
        @cancel="hideModal"
        @ok="deleteSelectedPattern"
        centered
      >
        <h6>آیا مایل به حذف الگو هستید؟</h6>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import PatternDependencies from "../components/PatternDependencies"
  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import * as $ from 'jquery';

  export default {
    name: "product-patterns",
    props: {},
    components: {
      VsSelect,
      PatternDependencies
    },
    data() {
      return {
        footerBgVariant: 'light',
        bodyBgVariant: 'light',
        headerBgVariant: 'danger',
        headerTextVariant: 'white',
        pagination: {
          pageIndex: 0,
          pageSize: 12,
        },
        pageCount: {},
        patterns: [],
        productsName: [],
        companies: [],
        selectedCompanies: [],
        productSelectedName: '',
        companySelectedId: 0,
        productId: 0,
        productSelectedVal: null,
        companySelectedVal: null,
        patternName: '',
        deleteButtonState: "primary",
        patternDecoration: 'deactive',
        deletePattern: {},
        stateItems: [],
        stateQuestions: [],
        // allQuestions: [],
        editingPattern: {
          pattern: undefined,
          preconditions: [],
          modifyConfirmForms: []
        },
        questionStateId: 0,
        standardTime: 0,
        deviceTime: 0,
        personTime: 0,
        transmitionTime: 0,
        isLoading: false,
      }
    },
    mounted() {
      this.getAllPatterns();
      this.getProducts();
      this.getCompanies();

      this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
        $(`#btn-delete-${this.deletePattern.id}`).removeClass("btn-danger");
        this.deletePattern = {}
      });
      this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
        $(`#btn-precondition-${this.editingPattern.pattern.id}`).removeClass("btn-warning")
      });
    },
    methods: {
      removePrecondition(val) {
        this.editingPattern.preconditions = this.editingPattern.preconditions.filter(a => a !== val);
      },
      addNewPrecondition(val) {
        // console.log(val);
        this.editingPattern.preconditions.push(val);
        // console.log(this.editingPattern.preconditions);
      },
      addNewQuestion(val) {
        // console.log(val)
        // this.editingPattern.modifyConfirmForms.push(val);
        // debugger
        let obj = {
          stateId: val.stateId,
          questions: val.questions.map(q => ({
            index: q.index,
            question: q.question,
            answerType: q.answerType.value,
            standardAnswer: q.standardAnswer,
          }))
        };
        const data = this.editingPattern.modifyConfirmForms.find(d => d.stateId === val.stateId);
        if (!data) {
          this.editingPattern.modifyConfirmForms.push(obj);
        } else {
          data.questions = val.questions;
        }


        // console.log(this.editingPattern.modifyConfirmForms)
      },
      getQuestionsOnly(id) {
        new BaseService('Patterns', `/GetModifyPatternViewData/${id}`).getList().then((response) => {
            // console.log(response.data);
            this.stateQuestions = response.data.map(q => ({
              id: q.id,
              questions: q.confirmForms
            }));
          }
        ).catch((error) => {
          console.log(error)
        });
      },
      patternDefult(item, index) {
        new BaseService('Patterns', `/SetPatternDefult/${item.id}`).update().then((response) => {
          this.$noty.success("الگو به عنوان پیش فرض ثبت شد");
          this.getAllPatterns();
        }).catch((error) => {
          this.getAllPatterns();
          console.log(error)
        })
      },
      createPatternDecoration(item, index) {
        this.questionStateId = item.id;
        new BaseService('Patterns', `/GetModifyPatternViewData/${item.id}`).getList().then((response) => {
            this.stateItems = response.data.map(a => ({
              id: a.id,
              companyName: a.companyName
            }));
            this.stateQuestions = response.data.map(q => ({
              id: q.id,
              questions: q.confirmForms
            }));
            this.editingPattern.preconditions = [];
            for (let a of response.data.filter(c => c.preconditions.length > 0)) {
              for (let pre of a.preconditions) {
                this.editingPattern.preconditions.push({
                  company: {
                    id: a.id,
                    name: a.companyName
                  },
                  preCompany: {
                    id: pre.id,
                    name: pre.companyName,
                    standardTime: pre.standardTime
                  },
                  receivedProducts: pre.products.map(p => ({
                    id: p.productId,
                    name: p.productName,
                    count: p.number,
                    storeDiscount: p.storeDiscount
                  }))
                })
              }
            }
            this.editingPattern.pattern = item;
            $(`#btn-precondition-${item.id}`).addClass("btn-warning");
            this.$root.$emit('bv::show::modal', 'pattern-preconditions', '#btnShow')
          }
        ).catch((error) => {
          console.log(error)
        });
      },
      savePatternDecoration() {
        // console.log(this.editingPattern.modifyConfirmForms)
        if (this.editingPattern.preconditions.length === 0) {
          this.$noty.error("جدول روابط کارگاه ها نمیتواند خالی باشد");
        } else {
          const model = {
            id: this.editingPattern.pattern.id,
            preconditions: this.editingPattern.preconditions.map(a => ({
              stateId: a.company.id,
              preconditionId: a.preCompany.id,
              standardTime: a.standardTime == null || a.standardTime === undefined ? 1 : a.standardTime,
              deviceTime: a.deviceTime == null || a.deviceTime === undefined ? 0 : a.deviceTime,
              personTime: a.personTime == null || a.personTime === undefined ? 0 : a.personTime,
              transmitionTime: a.transmitionTime == null || a.transmitionTime === undefined ? 0 : a.transmitionTime,
              receiveProducts: a.receivedProducts.map(r => ({
                productId: r.id,
                number: Number(r.count),
                storeDiscount: r.storeDiscount
              }))
            })),
            modifyConfirmForms: this.editingPattern.modifyConfirmForms.map(m => ({
              stateId: m.stateId,
              items: m.questions.map(q => ({
                answerType: q.answerType,
                index: q.index,
                question: q.question,
                standardAnswer: q.standardAnswer
              }))
            })),
          };
          new BaseService('Patterns', '/ModifyPatternPreconditions').create(model).then((response) => {
            this.$noty.success("الگو با موفقیت ویرایش شد");
            this.getAllPatterns();
          }).catch((error) => {
            this.getAllPatterns();
            console.log(error)
          })
        }
      },
      onDeleteClicked(item) {
        this.deletePattern = item;
        $(`#btn-delete-${item.id}`).addClass("btn-danger");
      },
      deleteSelectedPattern() {
        // console.log(this.deletePattern.id)
        let id = this.deletePattern.id;
        new BaseService('Patterns', `/RemovePattern/${id}`).delete().then((response) => {
          // console.log("pattern deleted ")
          // this.deleteButtonState = "primary";
          $(`#btn-delete-${id}`).removeClass("btn-danger");
          this.getAllPatterns();
          this.$noty.success("الگو با موفقیت حذف شد");
          this.deletePattern = {}
        }).catch((error) => {
          console.log(error);
          this.$noty.error("کار با این الگو در خط تولید وجود دارد و شما تا اتمام کار نمیتوانید این الگو را حذف کنید")
        })

      },
      onProductPaginationChange(pageIndex) {
        if (pageIndex) {
          this.pagination.pageIndex = pageIndex - 1;
          this.getAllPatterns(this.pagination.pageIndex)
        }
      },
      resetForm() {
        this.patternName = null;
        if (this.$refs.products) {
          this.$refs.products.$data.selectedValue = null;
        }
        if (this.$refs.companies) {
          this.$refs.companies.$data.selectedValue = null;
        }
        this.selectedCompanies = [];
      },
      getAllPatterns() {
        this.isLoading = true;
        new BaseService('Patterns', '/GetPatternsnew').getList(this.pagination).then((response) => {
          // console.log(response.data)
          this.isLoading = false;
          this.pageCount = response.data;
          this.patterns = response.data.data;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      savePattern() {
        let model = {
          name: this.patternName,
          productId: this.productId,
          companies: this.selectedCompanies
        };
        new BaseService('Patterns', '/CreatePattern').create(model).then((response) => {
          this.getAllPatterns();
          this.resetForm();
        }).catch((error) => {
          console.log(error)
        })
      },
      getCompanies() {
        new BaseService('Company', '/GetAllFamily').getList().then((response) => {
          // console.log(response.data)
          this.companies = response.data;
        }).catch((error) => {
          console.log(error)
        })
      },
      checkDefault(item) {
        if (item === true) {
          return "الگوی پیش فرض"
        } else {
          return "-"
        }
      },
      hideModal() {
        this.$refs.pattern.hide();
        this.$refs.deleteModal.hide();
        this.resetForm();
        $(`#btn-delete-${this.deletePattern.id}`).removeClass("btn-danger");
        setTimeout(() => {
          this.getAllPatterns();
          this.deletePattern.id = {}
        }, 1000)
      },
      onProductChange(val) {
        if (val !== null && val !== undefined) {
          this.productSelectedName = val.productName;
          this.productId = val.id;
          this.patternName = "الگوی " + val.productCode;
        }
      },
      onCompanyChange(val) {
        this.selectedCompanies = [];

        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.selectedCompanies.push(item.id)
          }
        }
      },
      getProducts() {
        new BaseService('Products', '/GetDropDownModel').getList().then((response) => {
          // console.log(response.data);
          this.productsName = response.data;
        }).catch((error) => {
          console.log(error)
        })
      },
    },
    computed: {
      rows() {
        return this.pageCount.count
      }
    },
    watch: {}
  }
  ;
</script>

<style scoped>


</style>
